<template>
  <div
    :class="`game ${hover && !found && !expertMode ? 'hover' : ''}`"
    @mousemove="onMouseMove"
    @touchmove="onMouseMove"
    @click="onClick"
  >
    <find-animal
      v-if="found"
      :animal="animal"
      :initialX="x"
      :initialY="y"
      @complete="onAnimalComplete"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { FIND_RADIUS } from 'constants';
import getAnimalObject from 'lib/getAnimalObject';
import getLevel from 'lib/getLevel';
import audioPlayer from 'lib/audioPlayer';
import Animal from 'components/Animal.vue';

function getEventCoordinates(e) {
  if (e.type.substr(0, 5) === 'mouse' || e.type === 'click') {
    return { x: e.clientX, y: e.clientY };
  } else if (e.type.substr(0, 5) === 'touch') {
    const touch = e.touches[0];
    return { x: touch.clientX, y: touch.clientY };
  }

  return null;
}

function getEventDistance(e, pos) {
  const { x, y } = getEventCoordinates(e);
  return Math.sqrt(Math.pow(pos.x - x, 2) + Math.pow(pos.y - y, 2));
}

function randomBetween(min, max) {
  return Math.round(min + (Math.random() * (max - min)));
}

const data = {
  components: {
    'find-animal': Animal,
  },
  mounted() {
    this.playSound();
    document.addEventListener('touchmove', this.onTouchMove, { passive: false });
  },
  beforeDestroy() {
    document.removeEventListener('touchmove', this.onTouchMove, { passive: false });
  },
  computed: mapState({
    animal: state => state.animal,
    expertMode: state => state.expertMode,
  }),
  data: () => ({
    x: randomBetween(FIND_RADIUS, document.documentElement.offsetWidth - FIND_RADIUS),
    y: randomBetween(FIND_RADIUS, document.documentElement.offsetHeight - FIND_RADIUS),
    level: 0,
    hover: false,
    found: false,
  }),
  methods: {
    onMouseMove(e) {
      const { offsetWidth, offsetHeight } = document.documentElement;
      const d = getEventDistance(e, { x: this.x, y: this.y });
      const maxD = Math.sqrt(Math.pow(offsetWidth, 2) + Math.pow(offsetHeight, 2));
      const animal = getAnimalObject(this.animal);
      this.level = getLevel(d, maxD, animal.maxLevel);

      this.hover = d <= FIND_RADIUS;
    },
    onTouchMove(e) {
      e.preventDefault();
      this.onMouseMove(e);
      this.onClick(e);
    },
    onClick(e) {
      const d = getEventDistance(e, { x: this.x, y: this.y });
      if (d <= FIND_RADIUS) {
        this.onFind();
      }
    },
    onFind() {
      this.found = true;
    },
    onAnimalComplete() {
      this.$store.dispatch('find');
    },
    playSound() {
      if (!this.found) {
        audioPlayer.play(this.animal, this.level).then(this.playSound);
      }
    },
  },
};

export default data;
</script>

<style lang="scss" scoped>
.game {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  &.hover {
    cursor: pointer;
  }
}
</style>



/** WEBPACK FOOTER **
 ** Game.vue?c07c4164
 **/